/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import team1 from "assets/images/avatar1.png";
import team2 from "assets/images/avatar2.png";
import team3 from "assets/images/avatar3.png";
import team4 from "assets/images/avatar4.png";
// Images
import profile1 from "assets/images/profile-1.png";
import profile2 from "assets/images/profile-2.png";
import profile3 from "assets/images/profile-3.png";
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Footer from "examples/Footer";
// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";
import Welcome from "../profile/components/Welcome/index";
import CarInformations from "./components/CarInformations";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { GetUserData, UpdateUserName, UserData } from "Api";
import { Form, Input, Button, Spin, message } from 'antd';
import { GetCredentials, UpdateUserData } from 'Api';

function Overview() {
  const [user, setUser] = useState(UserData.emtpy())
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [oldEmail, setOldEmail] = useState("");
  const [form] = Form.useForm();
  useEffect(() => {
    const auth = getAuth();
   const sub = auth.onAuthStateChanged((user) => {
    fetchData(user.uid, user.email)
   })

   return () =>{
    sub()
   }
  }, []);

  async function fetchData(uid, email){
    setLoading(true)
    const res = await GetUserData(uid);
    setUser(res)
    form.setFieldValue("name", res.name)
    form.setFieldValue("email", email)
    setOldEmail(email)
    setLoading(false)
  }

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setLoading(true)
   try {
    const auth = getAuth();
    const values = await form.validateFields();
    const email = values.email;
    const name = values.name;
    const password = values.password;
    await signInWithEmailAndPassword(auth, oldEmail, password)
    if(form.isFieldTouched("name")) await UpdateUserName(name);
    if(form.isFieldTouched("email")) await UpdateUserData(email);
    setIsEditing(false);
    form.resetFields()
    fetchData(auth.currentUser.uid, email)
    message.success("Profile data updated successfully")
   } catch (error) {
    message.error("Error updating profile data")
    console.log(error)
   }
    setLoading(false)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <VuiBox mt={5} mb={3}>
        <Grid
          container
          spacing={3}
          sx={({ breakpoints }) => ({
            [breakpoints.only("xl")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
          })}
        >
          <Grid
            item
            xs={12}
            xl={4}
            xxl={3}
            sx={({ breakpoints }) => ({
              minHeight: "400px",
              [breakpoints.only("xl")]: {
                gridArea: "1 / 1 / 2 / 2",
              },
            })}
          >
            <Welcome name={user.name}/>
          </Grid>
          <Grid
            item
            xs={12}
            xl={3}
            xxl={3}
            sx={({ breakpoints }) => ({
              [breakpoints.only("xl")]: {
                gridArea: "1 / 2 / 2 / 3",
              },
            })}
          >
           <Card>
           <Spin spinning={loading}>
      <Form form={form} layout="vertical">
        <Form.Item label="Name" name="name" initialValue={user.name} rules={[{ required: true, message: 'Please enter a name' }]}>
          <Input disabled={!isEditing} />
        </Form.Item>
        <Form.Item rules={[{ required: true, message: 'Please enter a valid email' }]}  label="Email" name="email" >
          <Input disabled={!isEditing}/>
        </Form.Item>
        {isEditing && <Form.Item label="Password" name="password">
          <Input.Password/>
        </Form.Item>}
      </Form>
      {isEditing ? (
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      ) : (
        <Button type="primary" onClick={handleEdit}>
          Edit
        </Button>
      )}
      /</Spin>
           </Card>
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
